export const GET_ALL_SPONSOR_LIST = 'GET_ALL_SPONSOR_LIST'
export const GET_ALL_SPONSOR_SUCCESS = 'GET_ALL_SPONSOR_SUCCESS'
export const GET_ALL_SPONSOR_FAIL = 'GET_ALL_SPONSOR_FAIL'
export const TOTAL_PAGE_SPONSOR = 'TOTAL_PAGE_SPONSOR'
export const CURRENT_PAGE = 'CURRENT_PAGE'
export const SANCTION_SHOPPING_CART = 'SANCTION_SHOPPING_CART'
export const SANCTION_SHOPPING_CART_SUCCESS = 'SANCTION_SHOPPING_CART_SUCCESS'
export const SANCTION_SHOPPING_PAYMENT_INTENT =
  'SANCTION_SHOPPING_PAYMENT_INTENT'
